import { css } from 'styled-components';
import { Iterable, pipe, Record } from '@blade/std-lib';
import { delugeLightTheme as delugeLightTheme_ } from './deluge-light-theme';
import { monokaiTheme as monokaiTheme_ } from './monokai-theme';
import { photgoneTheme as photgoneTheme_ } from './photgone-theme';
import { createThemeVariablesCss } from './theme-create';
import { figmaColors, uiKitDelugeTheme, uiKitTestTheme } from './theme-palette';
export const delugeTheme = {
    ...uiKitDelugeTheme,
};
export const delugeLightTheme = {
    ...delugeLightTheme_,
};
export const photgoneTheme = {
    ...photgoneTheme_,
};
export const monokaiTheme = {
    ...monokaiTheme_,
};
export const appTheme = delugeTheme;
export const testTheme = {
    ...uiKitTestTheme,
};
export const createFigmaVariables = () => pipe(Record.keys(figmaColors), Iterable.map((key) => `--figma-${key}: ${figmaColors[key]};`), Iterable.filter((it) => it !== undefined), Iterable.join('\n'));
export const themeVariablesCss = (theme) => css `
  ${createThemeVariablesCss(theme)}
  /* ${createFigmaVariables()} */
  ${css `
    ${['--test: #52FF00;', '--test2: #FF4034;'].join('\n')}
  `}
`;
export const mediaMinTablet = (styles) => css `
  @media (${({ theme }) => theme.tablet.queryMinWidth}) {
    ${styles}
  }
`;
export const mediaMaxTablet = (styles) => css `
  @media (${({ theme }) => theme.tablet.queryMaxWidth}) {
    ${styles}
  }
`;
export const mediaMaxMobile = (styles) => css `
  @media (${({ theme }) => theme.mobile.queryMaxWidth}) {
    ${styles}
  }
`;
export const mediaMaxDesktopSmall = (styles) => css `
  @media (${({ theme }) => theme.desktopSmall.queryMaxWidth}) {
    ${styles}
  }
`;
export const mediaMinDesktop = (styles) => css `
  @media (${({ theme }) => theme.desktop.queryMinWidth}) {
    ${styles}
  }
`;
export const mediaMinDesktopLarge = (styles) => css `
  @media (${({ theme }) => theme.desktopLarge.queryMinWidth}) {
    ${styles}
  }
`;
//# sourceMappingURL=theme.js.map